import React from 'react';
import { Element } from '@americanexpress/aqx-components';
import { isCardBlockedFromColorPicker } from 'src/universal/utils/cardColorChoices';

const DesignOptions = ({ shortName, content, styles }) => {
  const itemList = (content || []).map(item => {
    return { id: item.id, imgUrl: item?.appAssets?.backgroundImg };
  });

  return !isCardBlockedFromColorPicker(shortName) && itemList.length !== 0 ? (
    <Element className={styles.colorDiv}>
      {itemList.map((item, index) => (
        <img
          key={index}
          className={styles.designColor}
          src={item.imgUrl}
          alt={item.id}
        />
      ))}
    </Element>
  ) : (
    <div />
  );
};

export default DesignOptions;
